module.exports = __webpack_public_path__ + "static/media/Pizza Döner Time final.jpg.9f03ee23.png";